// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Sy03n","option":"styles_option__2kxES","active":"styles_active__2TqaJ"};